/* Enhances the shared header. The existing layout owns menu toggle + Escape. */
(function () {
  'use strict';
  var header = document.querySelector('[data-uth-persistent-header]');
  if (!header) return;
  var wrapper = header.closest('.shopify-section') || header;
  wrapper.classList.add('uth-persistent-header-section');
  var nav = header.querySelector('[data-uth-quick-nav]');
  var button = header.querySelector('[data-uth-burger]');
  var menu = header.querySelector('[data-uth-mobile-menu]');
  var originalCurrent = new Map();
  if (nav) nav.querySelectorAll('a').forEach(function (link) { originalCurrent.set(link, link.getAttribute('aria-current')); });
  function markCurrent() {
    if (!nav) return;
    nav.querySelectorAll('a').forEach(function (link) {
      var target = new URL(link.href, window.location.href);
      var current = null;
      if (target.origin === window.location.origin && target.pathname === window.location.pathname) {
        if (target.hash && target.hash === window.location.hash) current = 'location';
        else if (!target.hash) current = 'page';
      }
      if (!current && (!target.hash || target.hash === window.location.hash)) current = originalCurrent.get(link);
      if (current) link.setAttribute('aria-current', current); else link.removeAttribute('aria-current');
    });
  }
  var originalMargins = new Map();
  function measure() {
    var height = Math.ceil(wrapper.getBoundingClientRect().height) + 10;
    // Preserve larger existing anchor offsets. Touch only named page targets of header links.
    header.querySelectorAll('a[href*="#"]').forEach(function (link) {
      var url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;
      var target;
      try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (_) { return; }
      if (!target) return;
      if (!originalMargins.has(target)) originalMargins.set(target, parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0);
      target.style.scrollMarginTop = Math.max(originalMargins.get(target), height) + 'px';
    });
  }
  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth !== lastWidth && button && menu && button.getAttribute('aria-expanded') === 'true') {
      var returnFocus = menu.contains(document.activeElement);
      menu.classList.remove('is-open'); button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-label', 'Open menu');
      if (returnFocus) button.focus();
    }
    lastWidth = window.innerWidth; measure();
  });
  if (window.ResizeObserver) new ResizeObserver(measure).observe(wrapper);
  window.addEventListener('hashchange', markCurrent);
  window.addEventListener('pageshow', function () { markCurrent(); measure(); });
  markCurrent(); measure();
})();
